import { marked } from "marked";
import DOMPurify from "dompurify";
import TurndownService from "turndown";

const ALLOWED_TAGS = [
    "h1", "h2", "h3", "h4",
    "p", "strong", "em", "u",
    "ul", "ol", "li",
    "br", "a",
];
const ALLOWED_ATTR = ["href", "target", "rel"];

let hookInstalled = false;
function installAnchorHook() {
    if (hookInstalled) return;
    DOMPurify.addHook("afterSanitizeAttributes", (node) => {
        if (node.tagName === "A") {
            node.setAttribute("target", "_blank");
            node.setAttribute("rel", "noopener noreferrer");
        }
    });
    hookInstalled = true;
}

export function renderBioHtml(md: string | null | undefined): string {
    installAnchorHook();
    const html = marked.parse(md || "", { breaks: true, gfm: true, async: false }) as string;
    return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}

let turndown: TurndownService | null = null;
function getTurndown(): TurndownService {
    if (turndown) return turndown;
    // Note: do NOT pass `br: '  \n'`. Turndown's default `br: '  '` already
    // appends `\n` itself, so the soft-break round-trips as `  \n`; overriding
    // it produces `  \n\n`, which marked then re-renders as a paragraph break
    // and splits each soft line into its own paragraph.
    turndown = new TurndownService({
        headingStyle: "atx",
        bulletListMarker: "-",
    });
    turndown.keep(["u"]);
    return turndown;
}

export function htmlToMarkdown(html: string): string {
    return getTurndown().turndown(html || "");
}
